import React from 'react'

function ShopArea() {
  return (
	<section className="shop-area pt-120 pb-90">
        <div className="container">
          <div className="row align-items-center mb-30">
            <div className="col-sm-6">
              <div className="hf-section-title">
                <h1 className="title h1-black">OATTM Merchandise Store</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="https://oattm.com/product/oattm-unisex-hoodie/"><img src="assets/img/product/hoodie-oattm-store.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="https://oattm.com/product/oattm-unisex-hoodie/">OATTM Hoodie</a></h5>
                  <span>Price: £39.00</span>
                  <a href="https://oattm.com/product/oattm-unisex-hoodie/" className="shop-add-action">Buy Now</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="https://oattm.com/product/core-systems-organic-cotton-kids-t-shirt/"><img src="assets/img/product/oattm-organic-cotton-kids-t-shirt-black.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="https://oattm.com/product/core-systems-organic-cotton-kids-t-shirt/">OATTM T-Shirt</a></h5>
                  <span>Price: £14.99</span>
                  <a href="https://oattm.com/product/core-systems-organic-cotton-kids-t-shirt/" className="shop-add-action">Buy Now</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="https://oattm.com/product/t-rex-youth-crewneck-sweatshirt/"><img src="assets/img/product/oattm-youth-crew-neck-sweatshirt.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="https://oattm.com/product/t-rex-youth-crewneck-sweatshirt/">OATTM Sweatshirt</a></h5>
                  <span>Price: £16.00</span>
                  <a href="https://oattm.com/product/t-rex-youth-crewneck-sweatshirt/" className="shop-add-action">Buy Now</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
  )
}

export default ShopArea